/* eslint-disable ts/no-unsafe-assignment, ts/no-unsafe-member-access */
import type { AnyFieldApi } from '@tanstack/react-form'
import type { ApiErrorBody } from '@/api/client'
import { formatFieldErrors } from '@/components/forms/field-errors'
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
} from '@/components/ui/field'
import { Switch } from '@/components/ui/switch'

interface FormSwitchProps {
  field: AnyFieldApi
  label: string
  description?: string
  serverErrors?: ApiErrorBody['errors']
}

export function FormSwitch({
  field,
  label,
  description,
  serverErrors,
}: FormSwitchProps): React.ReactElement {
  const errors = formatFieldErrors(field.state.meta.errors)
  const serverMessages = serverErrors?.[field.name] ?? []
  const allErrors = [...errors, ...serverMessages]

  return (
    <div className="space-y-2">
      <FieldLabel htmlFor={field.name}>
        <Field orientation="horizontal">
          <FieldContent>
            <FieldTitle>{label}</FieldTitle>
            {description !== undefined && description !== '' && (
              <FieldDescription>{description}</FieldDescription>
            )}
          </FieldContent>
          <Switch
            id={field.name}
            checked={field.state.value === true}
            onCheckedChange={(checked) => field.handleChange(checked)}
            onBlur={field.handleBlur}
            aria-invalid={allErrors.length > 0}
            aria-describedby={allErrors.length > 0 ? `${field.name}-error` : undefined}
          />
        </Field>
      </FieldLabel>
      {allErrors.length > 0 && (
        <p id={`${field.name}-error`} className="text-destructive text-sm">
          {allErrors.join(', ')}
        </p>
      )}
    </div>
  )
}
